<template>
    <div class="comp-full-calendar">
        <!-- header pick month -->
        <fc-header :current-date="currentDate" :title-format="titleFormat" :first-day="firstDay" :month-names="monthNames" @change="emitChangeMonth">
            <div slot="header-left">
                <slot name="fc-header-left"></slot>
            </div>
            <div slot="header-right">
                <slot name="fc-header-right"></slot>
            </div>
        </fc-header>
        <fc-body :current-date="currentDate" :events="events" :month-names="monthNames" :week-names="weekNames" :first-day="firstDay" @eventclick="emitEventClick" @dayclick="emitDayClick" @moreclick="emitMoreClick">
            <div slot="body-card">
                <slot name="fc-body-card"></slot>
            </div>
        </fc-body>
    </div>
</template>

<script>
    import langSets from './langSets'

    export default {
        name: 'FullCalendar',
        props: {
            events: {
                type: Array,
                default: []
            },
            lang: {
                type: String,
                default: 'en'
            },
            firstDay: {
                type: Number | String,
                validator (val) {
                    let res = parseInt(val)
                    return res >= 0 && res <= 6
                },
                default: 0
            },
            titleFormat: {
                type: String,
                default () {
                    return langSets.titleFormat
                }
            },
            monthNames: {
                type: Array,
                default () {
                    return langSets.monthNames
                }
            },
            weekNames: {
                type: Array,
                default () {
                    let arr = langSets.weekNames
                    return arr.slice(this.firstDay).concat(arr.slice(0, this.firstDay))
                }
            }
        },
        data () {
            return {
                currentDate: new Date()
            }
        },
        methods: {
            emitChangeMonth (start, end, currentStart, current) {
                this.currentDate = current
                this.$emit('changeMonth', start, end, currentStart)
            },
            emitEventClick (event, jsEvent, pos) {
                this.$router.push({ name: 'deals.show.tasks', params: { id: event.deal_id } })
                this.$emit('eventClick', event, jsEvent, pos)
            },
            emitDayClick (day, jsEvent) {
                this.$emit('dayClick', day, jsEvent)
            },
            emitMoreClick (day, events, jsEvent) {
                this.$emit('moreClick', day, events, jsEvent)
            }
        },
        components: {
            'fc-body': require('./Body.vue').default,
            'fc-header': require('./Header.vue').default
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/helpers/full_calendar/Main.vue